import React from 'react';
import { AsteriskIcon } from 'evergreen-ui';
import { useSelector } from 'react-redux';
import { datasourceStatusDangerModeSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import StatusIcon from './StatusIcon';
import { DatasourceIdProps } from '../utils';
import { StatusDataType } from './utils';

export function DangerModeStatus({ datasourceId }: DatasourceIdProps) {
  const selectedZone = useSelector(timeZoneSelector);
  const status = useSelector(datasourceStatusDangerModeSelector(datasourceId));

  const { text, intent, time }: StatusDataType = React.useMemo(() => {
    const { isDanger, dateTimeUpdate } = status || {};

    if (isDanger === true) {
      return {
        time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
        text: 'Опасное',
        intent: 'danger',
      };
    }
    if (isDanger === false) {
      return {
        time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
        text: 'Не опасное',
        intent: 'success',
      };
    }

    return {
      time: '',
      text: 'Неизвестно',
      intent: 'none',
    };
  }, [selectedZone.selectedUserTimeZone, status]);

  return (
    <StatusIcon
      time={time}
      statusInfo={`Явление: ${text}`}
      intent={intent}
      icon={AsteriskIcon}
    />
  );
}
export default DangerModeStatus;
